var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState, useEffect } from "react";
import { checkMultiplier, EInvestmentType, firstInstallmentConstent, firstInstallmentConstentEnum, schemeErrors, } from "./MutualFundConstant";
import { acceptNumberOnly, } from "@frameworks/web/components/features/TOC/constant";
import RedeemError from "./CommonComp/RedeemError";
import MoreOptionsTxn from "./MoreOptionsTxn/MoreOptionsTxn";
import InputField from "@frameworks/web/components/generic/inputField";
import SipCalendar from "./CommonComp/SipCalendar";
import MandateType from "./MandateType/MandateType";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import { fundTypes } from "./MoreOptionsTxn/constants";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import { GenericDropdown, } from "@frameworks/shared-library/components/GenericDropdown";
import { EHoldingType } from "@domains/features/TOCJourney/entities/MFPurchaseOrderEntity";
import Edelicon from "@frameworks//web/components/generic/Edelicon";
import { dateSorting, ESortOrder } from "@domains/utils/sort";
import { isEmpty } from "@domains/utils/validation";
import moment from "moment";
import { getObjectFromInvestmentType } from "./MutualFund";
import { EOrderBookStatus } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
var MutualFundTransaction = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    // console.log('>>the props are', props)
    var _t = __read(useState(false), 2), schemeError = _t[0], setSchemeError = _t[1];
    var _u = __read(useState(), 2), sipData = _u[0], setSipData = _u[1];
    var _v = __read(useState(), 2), frequency = _v[0], setFrequency = _v[1];
    var _w = __read(useState(false), 2), loader = _w[0], setLoader = _w[1];
    var _x = __read(useState(false), 2), isCollapse = _x[0], setIsCollapse = _x[1];
    var _y = __read(useState({
        minAmt: Number((_b = getObjectFromInvestmentType(props.investmentType, props.mfData, props.investmentType === EInvestmentType.SIP
            ? (_a = props.purchaseFormData) === null || _a === void 0 ? void 0 : _a.sipFrequency
            : "MONTHLY")) === null || _b === void 0 ? void 0 : _b.minPurchaseAmt),
        maxAmt: Number((_d = getObjectFromInvestmentType(props.investmentType, props.mfData, props.investmentType === EInvestmentType.SIP
            ? (_c = props.purchaseFormData) === null || _c === void 0 ? void 0 : _c.sipFrequency
            : "MONTHLY")) === null || _d === void 0 ? void 0 : _d.maxPurchaseAmt),
        multiplier: Number((_f = getObjectFromInvestmentType(props.investmentType, props.mfData, props.investmentType === EInvestmentType.SIP
            ? (_e = props.purchaseFormData) === null || _e === void 0 ? void 0 : _e.sipFrequency
            : "MONTHLY")) === null || _f === void 0 ? void 0 : _f.purchaseAmtMul),
    }), 2), validate = _y[0], setValidate = _y[1];
    var handleFirstSipChange = function (val) {
        var _a;
        props.currentfirstInstallmentValueRef.current = val.value;
        // if pay later is selected and then we need to show only active mandates
        if (val.value === firstInstallmentConstentEnum.LATER) {
            var activeMandates = void 0;
            activeMandates = (_a = props === null || props === void 0 ? void 0 : props.mandateList) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.dpStatus === "Active"; });
            props === null || props === void 0 ? void 0 : props.setMandateList(activeMandates);
            if (isEmpty(activeMandates)) {
                props === null || props === void 0 ? void 0 : props.setSelectedMandate(null);
            }
            else {
                var maxValidityObject = activeMandates.reduce(function (max, obj) {
                    return new Date(obj.expiryDate) > new Date(max.expiryDate) ? obj : max;
                });
                props === null || props === void 0 ? void 0 : props.setSelectedMandate(maxValidityObject);
                props === null || props === void 0 ? void 0 : props.setSelectedMandateId(maxValidityObject.mandateId);
            }
        }
        props.getSipStartDateData(props.purchaseFormData.sipFrequency, val.value);
        props.setPurchaseFormData(function (pData) {
            return __assign(__assign({}, pData), { firstInstallmentConstent: val.value, firstInstallment: val.value });
        });
        if (val.value === firstInstallmentConstentEnum.NOW) {
            props.getMfMandate();
        }
    };
    var sipFreq = useMemo(function () {
        var _a, _b, _c;
        try {
            if (((_a = props.startDate) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var dateList = dateSorting(props.startDate, null, ESortOrder.DESC);
                var freq_1 = __spreadArray([], __read(Array(28)), false);
                var maxOneMonth_1 = moment(dateList[0]).add(1, "M");
                dateList
                    .filter(function (k) { return Number(k.split(" ")[0]) <= 28; })
                    .slice(0, 28)
                    .map(function (z) {
                    if (freq_1[Number(z.split(" ")[0]) - 1] === undefined ||
                        moment(maxOneMonth_1).diff(z) > 0) {
                        freq_1[Number(z.split(" ")[0]) - 1] = {
                            label: Number(z.split(" ")[0]),
                            value: z,
                        };
                    }
                });
                freq_1 = freq_1.map(function (z, i) {
                    if (z === undefined) {
                        return {
                            label: i + 1,
                            value: "",
                        };
                    }
                    return z;
                });
                if (((_b = props.purchaseFormData) === null || _b === void 0 ? void 0 : _b.sipDate) &&
                    !((_c = freq_1
                        .map(function (item) { return item.value; })) === null || _c === void 0 ? void 0 : _c.includes(props.purchaseFormData.sipDate))) {
                    props.setPurchaseFormData(function (fData) {
                        return __assign(__assign({}, fData), { sipDate: getAlternateSipDate(freq_1) });
                    });
                }
                return freq_1;
            }
        }
        catch (e) {
            //console.log(e);
        }
    }, [props.startDate]);
    var getAlternateSipDate = function (sortedSipDateList) {
        var sipDate = props.purchaseFormData.sipDate;
        // check if sipdate exists in freq List &&
        // Loop through props.startDate and check each item
        var i = 0;
        while (!sortedSipDateList.some(function (item) { return item.value === sipDate; }) &&
            i < props.startDate.length) {
            // If sipDate is not found in freq, set sipDate to the next item in props.startDate.
            sipDate = props.startDate[++i];
        }
        return sipDate;
    };
    var firstInstallmentOptions = useMemo(function () {
        //1. if maxgap is equal to 0 then diable Later
        var options = firstInstallmentConstent;
        // 1.if minGap greater than 0 then Now should be disable ---  remove from validation
        // if (sipData?.minGapInDay > 0) {
        //   delete options[0];
        // }
        if ((sipData === null || sipData === void 0 ? void 0 : sipData.maxGapInDay) == 0) {
            delete options[1];
        }
        return options;
    }, [sipData === null || sipData === void 0 ? void 0 : sipData.minGapInDay, sipData === null || sipData === void 0 ? void 0 : sipData.maxGapInDay]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var min, max, mul;
        var amt = Number((_a = props.purchaseFormData) === null || _a === void 0 ? void 0 : _a.amount);
        if (props.investmentType === EInvestmentType.LUMPSUM) {
            if ((_b = props.mfData) === null || _b === void 0 ? void 0 : _b.lumpsumData) {
                min =
                    props.purchaseType === "AP"
                        ? Number((_d = (_c = props.mfData) === null || _c === void 0 ? void 0 : _c.lumpsumData["MONTHLY"]) === null || _d === void 0 ? void 0 : _d.addPurchaseAmtMul)
                        : Number((_f = (_e = props.mfData) === null || _e === void 0 ? void 0 : _e.lumpsumData["MONTHLY"]) === null || _f === void 0 ? void 0 : _f.minPurchaseAmt);
                max = Number((_h = (_g = props.mfData) === null || _g === void 0 ? void 0 : _g.lumpsumData["MONTHLY"]) === null || _h === void 0 ? void 0 : _h.maxPurchaseAmt);
                mul = Number((_k = (_j = props.mfData) === null || _j === void 0 ? void 0 : _j.lumpsumData["MONTHLY"]) === null || _k === void 0 ? void 0 : _k.purchaseAmtMul);
                setValidate(function (val) {
                    var _a, _b;
                    return __assign(__assign({}, val), { minAmt: min, maxAmt: max, multiplier: Number((_b = (_a = props.mfData) === null || _a === void 0 ? void 0 : _a.lumpsumData["MONTHLY"]) === null || _b === void 0 ? void 0 : _b.purchaseAmtMul) });
                });
            }
        }
        else {
            if (sipData) {
                min = Number(sipData === null || sipData === void 0 ? void 0 : sipData.minInstAmt);
                max = Number(sipData === null || sipData === void 0 ? void 0 : sipData.maxInstAmt);
                mul = Number(sipData === null || sipData === void 0 ? void 0 : sipData.mul);
                setValidate(function (val) {
                    return {
                        minAmt: min,
                        maxAmt: max,
                        multiplier: Number(sipData === null || sipData === void 0 ? void 0 : sipData.mul),
                    };
                });
            }
        }
        if (amt && (amt > max || amt < min)) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "The amount must be between ".concat(min, " and ").concat(max),
                } }));
        }
        else if (amt && checkMultiplier(amt, mul)) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Please ensure that the ".concat(props.investmentType === EInvestmentType.SIP ? "SIP" : "", " amount is in multiples of ").concat(mul),
                } }));
        }
        else {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: false,
                    msg: "",
                } }));
        }
    }, [props.investmentType, props.purchaseFormData, props.schemeCode, sipData]);
    useEffect(function () {
        var _a, _b, _c;
        if ((_a = props.mfData) === null || _a === void 0 ? void 0 : _a.sipData) {
            setSipData((_b = props.mfData) === null || _b === void 0 ? void 0 : _b.sipData[(_c = props.purchaseFormData) === null || _c === void 0 ? void 0 : _c.sipFrequency]);
        }
    }, [(_g = props.purchaseFormData) === null || _g === void 0 ? void 0 : _g.sipFrequency, props.schemeCode, props.mfData]);
    useEffect(function () {
        var _a;
        setLoader(true);
        var frequency = (_a = props.mfData) === null || _a === void 0 ? void 0 : _a.sipFrequency;
        if (props.physicalFlg == EHoldingType.Demat && (frequency === null || frequency === void 0 ? void 0 : frequency.length) > 0) {
            frequency = frequency.filter(function (item) { return item.value !== "DAILY"; });
        }
        setFrequency(frequency);
        setTimeout(function () {
            setLoader(false);
        }, 100);
    }, [(_h = props.mfData) === null || _h === void 0 ? void 0 : _h.sipFrequency, props.schemeCode, props.physicalFlg]);
    // useEffect(() => {
    //   if (!props.isModify) {
    //     // avoid set default values
    //     props.setPurchaseFormData((pData: MFFormData) => {
    //       return { ...pData, amount: "" };
    //     });
    //     props.setFormErrors({
    //       ...props.formErrors,
    //       amount: { status: false, msg: `` },
    //     });
    //   }
    // }, [props.investmentType]);
    return (React.createElement(React.Fragment, null,
        !schemeError && (React.createElement("div", { className: "primary-side-txn-form-container d-flex flex-column justify-content-between position-relative" },
            React.createElement("div", { className: "bg_white z-100", onClick: function () { return props.setShowScheme && props.setShowScheme(false); } },
                React.createElement("div", { className: "upper-form-panel" },
                    React.createElement("div", { className: "primary_sip_txn_container" },
                        React.createElement("div", null,
                            React.createElement("div", { className: "d-flex" },
                                React.createElement("span", { className: "DMSans_13_400 txt_blackOne1 mgr-10" },
                                    props.investmentType,
                                    " Amount"),
                                props.investmentType === EInvestmentType.SIP &&
                                    !loader &&
                                    (frequency === null || frequency === void 0 ? void 0 : frequency.length) > 0 && (React.createElement(GenericDropdown, { itemlist: JSON.parse(JSON.stringify(frequency)), defaultVal: true, selectedDefaultVal: frequency.find(function (x) {
                                        return x.value === props.purchaseFormData.sipFrequency;
                                    }), selectedValue: function (val) {
                                        props.getSipStartDateData(val.value);
                                        props.setPurchaseFormData(function (fData) {
                                            return __assign(__assign({}, fData), { sipFrequency: val.value });
                                        });
                                        props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: { status: false, msg: "" } }));
                                        props.setPurchaseFormData(function (pData) {
                                            return __assign(__assign({}, pData), { amount: "" });
                                        });
                                    }, externalClassname: "mf-txn-dropdown" }))),
                            React.createElement("div", null,
                                React.createElement(InputField, { autofocus: true, inputMode: "numeric", type: "number", 
                                    // max={999}
                                    placeholder: "Enter amount", defaultValue: (_j = props.purchaseFormData) === null || _j === void 0 ? void 0 : _j.amount, value: (_k = props.purchaseFormData) === null || _k === void 0 ? void 0 : _k.amount, inputPattern: "[0-9]*", placeholderClassName: "amount txt_dull-grey ", 
                                    // maxLength={validate.maxAmt.toString().length}
                                    className: "custom-box", autoComplete: "off", onChange: function (value) {
                                        if (/^0\d/.test(value)) {
                                            value = value.replace(/^0+/, "");
                                        }
                                        var valueNum = Number(value);
                                        props.setPurchaseFormData(function (pData) {
                                            return __assign(__assign({}, pData), { amount: value });
                                        });
                                        if (!valueNum || (valueNum && valueNum <= 0)) {
                                            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                                                    status: true,
                                                    msg: "Amount can not be blank or 0",
                                                } }));
                                        }
                                        else if (valueNum &&
                                            (valueNum < Number(validate.minAmt) ||
                                                valueNum > Number(validate.maxAmt))) {
                                            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                                                    status: true,
                                                    msg: "The amount must be between ".concat(validate.minAmt, " and ").concat(validate.maxAmt),
                                                } }));
                                        }
                                        else if (checkMultiplier(valueNum, validate.multiplier)) {
                                            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                                                    status: true,
                                                    msg: "Please ensure that the ".concat(props.investmentType === EInvestmentType.SIP
                                                        ? "SIP"
                                                        : "", " amount is in multiples of ").concat(validate.multiplier),
                                                } }));
                                        }
                                        else {
                                            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: { status: false, msg: "" } }));
                                        }
                                    }, onKeyDown: function (e) {
                                        if (acceptNumberOnly(e.key)) {
                                            e.preventDefault();
                                        }
                                    }, onWheel: function (e) {
                                        return e.currentTarget.blur();
                                    }, required: true }, ((_l = props.purchaseFormData) === null || _l === void 0 ? void 0 : _l.amount) && (React.createElement("div", { className: "rupee__icon" },
                                    React.createElement("span", null, "\u20B9")))),
                                props.formErrors.amount.status && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 d-flex" },
                                    React.createElement("span", null, props.formErrors.amount.msg))),
                                React.createElement("span", { className: "DMSansNormal_12_400 text_box_bottom" },
                                    "Min. \u20B9",
                                    validate.minAmt,
                                    " (Multiple of \u20B9",
                                    validate.multiplier,
                                    ")"))),
                        props.investmentType === EInvestmentType.LUMPSUM &&
                            props.availableHoldings.length > 1 && (React.createElement("div", { className: "child-container d-flex flex-row align-items-start gap-3 mgt-30" },
                            React.createElement("div", { className: "flex-grow-2" },
                                React.createElement("div", { className: "d-flex align-items-center gap-2" },
                                    React.createElement(GenericTooltip, { placement: "bottom-start", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "Select how to hold your mutual fund units:", tooltipCustom: fundTypes }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("span", { className: "DMSanN_13_400 d-flex flex-row align-items-center" },
                                            "Holding Type",
                                            React.createElement("i", { className: "edel-icon-Information txt_secondary-gray mgl-5" })) })),
                                React.createElement("div", { className: "mgt-8" },
                                    React.createElement(MandateType, { recommendedType: props.availableHoldings.length > 1
                                            ? EHoldingType.Demat
                                            : "", availableList: props.availableHoldings, selected: props.physicalFlg, setPhysicalFlg: props.setPhysicalFlg }))))),
                        props.investmentType === EInvestmentType.SIP && (React.createElement("div", { className: "mgt-30" },
                            React.createElement("div", { className: "d-flex" },
                                React.createElement("span", { className: "DMSans_13_400 mgr-10 txt_blackOne1" }, props.isModify &&
                                    props.displayStatus === EOrderBookStatus.ACTIVE
                                    ? "Sip installment date"
                                    : "Pay first SIP installment"),
                                props.isModify &&
                                    props.displayStatus === EOrderBookStatus.ACTIVE ? null : (React.createElement(GenericDropdown, { itemlist: firstInstallmentOptions, defaultVal: true, selectedDefaultVal: props.isModify &&
                                        props.displayStatus === EOrderBookStatus.ACTIVE
                                        ? {
                                            title: "Later",
                                            value: firstInstallmentConstentEnum.LATER,
                                        }
                                        : firstInstallmentOptions.find(function (item) {
                                            var _a;
                                            return item.value ===
                                                ((_a = props.purchaseFormData) === null || _a === void 0 ? void 0 : _a.firstInstallment);
                                        }), selectedValue: handleFirstSipChange, externalClassname: "mf-txn-dropdown" }))),
                            React.createElement("span", null, ((_m = props.startDate) === null || _m === void 0 ? void 0 : _m.length) > 0 && (React.createElement(SipCalendar, { selectedVal: (_o = props.purchaseFormData) === null || _o === void 0 ? void 0 : _o.sipDate, setSelectedVal: function (value) {
                                    props.setPurchaseFormData(function (pData) {
                                        return __assign(__assign({}, pData), { sipDate: value.value });
                                    });
                                }, dateList: sipFreq, closeOnOutSideClick: true, setIsCalendarOpen: props.setIsSipCalendarOpen, selectedFrequency: (_p = props.purchaseFormData) === null || _p === void 0 ? void 0 : _p.sipFrequency, isPayNow: ((_q = props === null || props === void 0 ? void 0 : props.purchaseFormData) === null || _q === void 0 ? void 0 : _q.firstInstallment) ===
                                    firstInstallmentConstentEnum.NOW }))),
                            ((_s = (_r = props.formErrors) === null || _r === void 0 ? void 0 : _r.startDate) === null || _s === void 0 ? void 0 : _s.status) && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 d-flex" },
                                React.createElement("span", null, props.formErrors.startDate.msg))))))),
                props.investmentType === EInvestmentType.SIP && (React.createElement("div", { className: "position-relative" },
                    React.createElement("div", { className: "DMSans_13_400 text-center mgt-30 d-flex gap-1 pdl-20 pb-15", onClick: function () { return setIsCollapse(!isCollapse); } },
                        React.createElement("span", { className: "DMSans_13_400 txt-han-blue" }, "More Options"),
                        React.createElement("div", { className: "d-flex align-items-center txt-han-blue" },
                            React.createElement("span", { className: isCollapse
                                    ? "edel-icon-arrow-up-thin"
                                    : "edel-icon-arrow-down" }))),
                    (!props.selectedMandate || isCollapse) && (React.createElement("span", null,
                        React.createElement("div", { className: "w-100 bg_ghost-white3 position-absolute z-100" },
                            React.createElement(MoreOptionsTxn, { investmentType: props.investmentType, selectedMandate: props.selectedMandate, setTOCFlow: props.setTOCFlow, selected: props.physicalFlg, setPhysicalFlg: props.setPhysicalFlg, mfData: props.mfData, purchaseFormData: props.purchaseFormData, setPurchaseFormData: props.setPurchaseFormData, isModify: props.isModify, setSelectedMandate: props.setSelectedMandate, setSelectedMandateId: props.setSelectedMandateId, setFormErrors: props === null || props === void 0 ? void 0 : props.setFormErrors, availableHoldings: props.availableHoldings, displayStatus: props.displayStatus }))))))),
            React.createElement("div", { className: "d-flex justify-content-end pt-10 position-absolute side-txn-bg-image-container" },
                React.createElement(Edelicon, { className: "edel-icon-save-money-hand2", paths: 80 })))),
        schemeError && React.createElement(RedeemError, { errorMsg: schemeErrors["purchase"] })));
};
export default MutualFundTransaction;
